<template>
  <div class="section_container">
    <div id="yes_or_no_content">
      <div id="yes_or_no_box">
        <span class="question">PLEASE ENTER A QUESTION</span>
        <span class="question_mark">?</span>
        <input @keypress="handleInput"/>
        <span class="submit_button" @click="process">SUBMIT</span>
        <div id="thumbs">
          <div>
            <a id="thumb_up" href="#">
              <img v-if="answer == 'yes'" src="../assets/images/thumb_up_colored.png">
              <img v-else src="../assets/images/thumb_up.png">
            </a>
            <span id="yes" :style="{color: yes_color}">YES!</span>
            <div id="timer">
              <img v-visible="reveal_timer >= 4" class="timer_item" id="quarter_4" style="width:77px;" src="../assets/images/timer_0_0.png"/>
              <img v-visible="reveal_timer >= 1" class="timer_item" id="quarter_1" src="../assets/images/timer_0_1.png"/>
              <img v-visible="reveal_timer >= 3" class="timer_item" id="quarter_3" style="width:77px;" src="../assets/images/timer_1_0.png"/>
              <img v-visible="reveal_timer >= 2" class="timer_item" id="quarter_2" src="../assets/images/timer_1_1.png"/>
            </div>
            <span id="no" :style="{color : no_color}">NO!</span>
            <a id="thumb_down" href="#">
              <img v-if="answer == 'no'" src="../assets/images/thumb_down_colored.png">
              <img v-else src="../assets/images/thumb_down.png">
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function(){
    return {
      name: 'YesOrNoVue',
      reveal_timer: 0,
      answer: null,
      yes_color: 'white',
      no_color: 'white'
    }
  },
  methods: {
    handleInput: function(e){
      if(e.key == "Enter")
        this.process();
    },
    process: function(){
      var i = setInterval(() => {
        if(++(this.reveal_timer) == 4){
          clearInterval(i);
          this.answer = (Math.random()<0.5) ? 'no' : 'yes';
          this.yes_color = (this.answer == 'yes') ? '#3AB17C' : 'white';
          this.no_color = (this.answer == 'no') ? '#FFD675' : 'white';
        }
      }, 500);
    }
  }
}
</script>

<style scoped>
  .section_container{
    position: relative;
    width: 100%;
  }

  .submit_button{
    margin-top: 30px;
    margin-bottom: 50px;
  }

  @media screen and (max-width: 768px){
    .submit_button{
      font-size: 35px;
      line-height: 1;
      padding: 5px 35px;
      margin-bottom: 15px;
    }
  }
</style>